// extracted by mini-css-extract-plugin
export default {"platformLabel":"PlatformTag_platformLabel__5GDPZ"};